(function(){
  'use strict';
  function setupFooter(root){
    var desktop=window.matchMedia('(min-width:750px)').matches;
    (root||document).querySelectorAll('[data-saans-footer]').forEach(function(group){group.open=desktop;});
  }
  setupFooter();
  window.matchMedia('(min-width:750px)').addEventListener('change',function(){setupFooter();});
  document.addEventListener('shopify:section:load',function(event){setupFooter(event.target);});
  document.addEventListener('click',function(event){
    if(event.target.closest('[data-saans-footer] > summary')&&window.matchMedia('(min-width:750px)').matches)event.preventDefault();
  });

  document.addEventListener('keydown',function(event){
    if(event.key!=='Escape')return;
    if(window.saansWaToggle)window.saansWaToggle(false);
    if(window.saansCloseGiftTheme)window.saansCloseGiftTheme();
    if(window.saansCloseDR)window.saansCloseDR();
  });
  document.addEventListener('click',function(event){
    var button=event.target.closest('[data-drawer-open]');
    if(button)button.setAttribute('aria-expanded','true');
  });
  if(!window.Saans.offers_enabled){
    document.querySelectorAll('[data-gl-bundle-progress]').forEach(function(element){element.hidden=true;});
  }

  /* Make cart drawer product images and names open the relevant product page. */
  (function setupCartProductLinks(){
    var body=document.getElementById('cart-drawer-body');
    if(!body || !window.MutationObserver) return;
    var running=false;
    function enhance(){
      if(running) return;
      var rows=body.querySelectorAll('.cd-item');
      if(!rows.length) return;
      var needsWork=false;
      rows.forEach(function(row){
        var img=row.querySelector('.cd-thumb img[data-product-id]');
        var title=row.querySelector('.cd-t');
        if((img && !img.closest('a')) || (title && !title.querySelector('a'))) needsWork=true;
      });
      if(!needsWork) return;
      running=true;
      fetch('/cart.js',{headers:{'Accept':'application/json'}})
        .then(function(response){return response.ok?response.json():null;})
        .then(function(cart){
          if(!cart || !Array.isArray(cart.items)) return;
          var urls={};
          cart.items.forEach(function(item){
            if(item.product_id && item.url) urls[String(item.product_id)]=item.url;
            else if(item.product_id && item.handle) urls[String(item.product_id)]='/products/'+item.handle;
          });
          body.querySelectorAll('.cd-item').forEach(function(row){
            var img=row.querySelector('.cd-thumb img[data-product-id]');
            var title=row.querySelector('.cd-t');
            var productId=img && img.getAttribute('data-product-id');
            var url=productId && urls[String(productId)];
            if(!url || url.charAt(0)!=='/') return;
            if(img && !img.closest('a')){
              var imageLink=document.createElement('a');
              imageLink.href=url;
              imageLink.className='cd-product-link';
              imageLink.setAttribute('aria-label','View '+((img.getAttribute('alt')||'product').trim()));
              imageLink.style.display='block';
              img.parentNode.insertBefore(imageLink,img);
              imageLink.appendChild(img);
            }
            if(title && !title.querySelector('a')){
              var titleLink=document.createElement('a');
              titleLink.href=url;
              titleLink.className='cd-product-link';
              titleLink.style.color='inherit';
              titleLink.style.textDecoration='none';
              titleLink.textContent=title.textContent;
              title.textContent='';
              title.appendChild(titleLink);
            }
          });
        })
        .catch(function(){})
        .finally(function(){running=false;});
    }
    var observer=new MutationObserver(function(){enhance();});
    observer.observe(body,{childList:true,subtree:true});
    enhance();
  })();

})();

/* Mobile collection filter UX: sticky header, bottom apply, auto-apply, swipe close */
(function(){
  function initFilterDrawer(){
    var drawer=document.getElementById('filters');
    if(!drawer || drawer.dataset.saansUxReady==='1') return;
    drawer.dataset.saansUxReady='1';
    var header=drawer.querySelector('.fdrawer-head, .fd-head, .filters-head, .drawer-head, header') || drawer.firstElementChild;
    if(header) header.classList.add('saans-filter-sticky-head');
    var footer=document.createElement('div');
    footer.className='saans-filter-sticky-footer';
    var apply=document.createElement('button');
    apply.type='button'; apply.className='saans-filter-apply'; apply.textContent='Done';
    apply.addEventListener('click',function(){
      if(window.saansFilters) window.saansFilters(false);
      else { drawer.classList.remove('open'); document.body.style.overflow=''; }
    });
    footer.appendChild(apply); drawer.appendChild(footer);
    /* Filters are applied client-side by the collection section's change handler.
       Do not submit the native Shopify filter form when a checkbox changes. */
    var startX=0,startY=0;
    drawer.addEventListener('touchstart',function(e){if(e.touches&&e.touches[0]){startX=e.touches[0].clientX;startY=e.touches[0].clientY;}},{passive:true});
    drawer.addEventListener('touchend',function(e){
      if(!e.changedTouches||!e.changedTouches[0])return;
      var dx=e.changedTouches[0].clientX-startX,dy=e.changedTouches[0].clientY-startY;
      if(dx < -90 && Math.abs(dx)>Math.abs(dy)*1.25 && window.saansFilters) window.saansFilters(false);
    },{passive:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initFilterDrawer); else initFilterDrawer();
  document.addEventListener('shopify:section:load',initFilterDrawer);
  new MutationObserver(function(){initFilterDrawer();}).observe(document.documentElement,{childList:true,subtree:true});
})();

/* Buy Now handler for the product-page button rendered in Liquid */
(function(){
  if(window.__saansBuyNowHandler) return;
  window.__saansBuyNowHandler=true;
  document.addEventListener('click',function(event){
    var button=event.target.closest('[data-saans-buy-now]');
    if(!button) return;
    var form=button.closest('form[data-add-to-cart]') || document.querySelector('form[data-add-to-cart][id^="pform-"]');
    if(!form) { alert('Please refresh the product page and try again.'); return; }
    var variant=form.querySelector('select[name="id"]');
    var qty=form.querySelector('[name="quantity"]');
    var addButton=form.querySelector('[data-atc]');
    var id=variant && variant.value;
    var quantity=Math.max(1,parseInt(qty && qty.value || '1',10)||1);
    if(!id || button.dataset.loading==='1') return;
    button.dataset.loading='1';button.disabled=true;button.textContent='Opening checkout…';
    var root=(window.Shopify && window.Shopify.routes && window.Shopify.routes.root)||'/';
    if(root.charAt(root.length-1)!=='/') root+='/';
    var controller=window.AbortController?new AbortController():null;
    var timeout=controller?setTimeout(function(){controller.abort();},12000):null;
    fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:quantity}]}),signal:controller?controller.signal:undefined})
      .then(function(response){if(!response.ok)return response.json().catch(function(){return {};}).then(function(err){throw new Error(err.description||'Could not add this item.');});return response.json();})
      .then(function(){window.location.assign(root+'checkout');})
      .catch(function(err){button.dataset.loading='0';button.disabled=!!(addButton&&addButton.disabled);button.textContent='Buy Now';alert(err&&err.name==='AbortError'?'Checkout is taking too long. Please use Add to Cart and continue from your cart.':((err&&err.message)||'Please use Add to Cart and try again.'));})
      .finally(function(){if(timeout)clearTimeout(timeout);});
  });
})();

/* Reliable mobile collection filter drawer controls */
(function(){
  function openFilters(){
    var side=document.getElementById('filters'), bg=document.getElementById('fbg');
    if(!side)return;
    side.classList.add('open'); side.setAttribute('aria-hidden','false');
    if(bg){bg.classList.add('on');bg.setAttribute('aria-hidden','false');}
    document.body.style.overflow='hidden';
  }
  function closeFilters(){
    var side=document.getElementById('filters'), bg=document.getElementById('fbg');
    if(side){side.classList.remove('open');side.setAttribute('aria-hidden','true');}
    if(bg){bg.classList.remove('on');bg.setAttribute('aria-hidden','true');}
    document.body.style.overflow='';
  }
  window.saansFilters=function(open){if(open)openFilters();else closeFilters();};
  document.addEventListener('click',function(e){
    if(e.target.closest('.fbtn')){e.preventDefault();openFilters();return;}
    if(e.target.closest('.fclose')){e.preventDefault();closeFilters();return;}
    if(e.target.closest('#fbg')){closeFilters();return;}
    var colour=e.target.closest('[data-shop-colour]');
    if(colour){
      var selected=colour.getAttribute('data-shop-colour').toLowerCase();
      var side=document.getElementById('colFilters');
      if(side){
        var inputs=[].slice.call(side.querySelectorAll('.cfColour'));
        var match=inputs.find(function(input){return input.value.toLowerCase()===selected;});
        if(match){match.checked=!match.checked;match.dispatchEvent(new Event('change',{bubbles:true}));}
        openFilters();
      }
    }
  },true);
})();
